import { render, staticRenderFns } from "./central-dashboard.vue?vue&type=template&id=47bcfd04&"
import script from "./central-dashboard.vue?vue&type=script&lang=js&"
export * from "./central-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./central-dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports